// routeConfig.js

import { DashboardOutlined, UserOutlined, SettingOutlined } from '@ant-design/icons';

export const routesConfig = [
  {
    key: '1',
    path: '/dashboard',
    title: 'Dashboard',
    icon: <DashboardOutlined />,
    requiredResource: 'dashboard',
  },
  {
    key: '2',
    path: '/users',
    title: 'Users',
    icon: <UserOutlined />,
    requiredResource: 'user',
  },
  {
    key: '3',
    path: '/users',
    title: 'Users',
    icon: <UserOutlined />,
    requiredResource: 'users',
  },
  {
    key: '4',
    path: '/configurations',
    title: 'Configurations',
    icon: <SettingOutlined />,
    requiredResource: 'configurations',
  },
  // Add other routes similarly...
];
